import { AvailableWidget } from "ui/components/Grid/types";
import { FleetTireSet } from "services/api/fleet/tires/types";
import TireSetInfoCard from "./components/TireSetInfoCard/TireSetInfoCard";
import TireSetTiresCard from "./components/TireSetTiresCard/TireSetTiresCard";

export const TIRE_SET_AVAILABLE_WIDGETS = (
    t: (key: string) => string,
    tireSet: FleetTireSet,
): AvailableWidget[] => [
    {
        id: "widget-tire-set-info",
        name: "Informacije o setu",
        icon: "",
        header: <></>,
        component: <TireSetInfoCard tireSet={tireSet} />,
    },
    {
        id: "widget-tire-set-tires",
        name: "Gume u setu",
        icon: "",
        header: <></>,
        component: <TireSetTiresCard tires={tireSet.tires} />,
    },
];
